import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-user-idle-timeout-dialog',
  templateUrl: './user-idle-timeout-dialog.component.html',
})
export class UserIdleTimeoutDialogComponent implements OnInit {
  countdown: BehaviorSubject<number>;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { countdown: BehaviorSubject<number> },
  ) {}

  ngOnInit() {
    this.countdown = this.data.countdown;
  }
}
